import { axiosPublic } from "../axios";
import { useDispatch } from "react-redux";
import { setAuthToken, clearAuthData } from "../store/authSlice";
import { clearAllUserData } from "../store/userSlice";

const useRefreshToken = () => {
  const dispatch = useDispatch();

  const refresh = async () => {
    try {
      // Получаем текущий токен для обновления
      const currentToken =
        localStorage.getItem("auth_token") ||
        JSON.parse(localStorage.getItem("authState") || "{}").auth_token;

      if (!currentToken) {
        throw new Error("No token to refresh");
      }

      console.log("🔄 [useRefreshToken] Refreshing token...");
      console.log(
        "🔑 [useRefreshToken] Current token preview:",
        currentToken.substring(0, 30) + "..."
      );

      const response = await axiosPublic.get("/auth/refresh", {
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${currentToken}`,
        },
      });

      const newToken = response?.data?.accessToken;
      console.log(
        "✅ [useRefreshToken] New token received:",
        newToken?.substring(0, 30) + "..."
      );

      // Сохраняем новый токен в localStorage напрямую
      localStorage.setItem("auth_token", newToken);

      // Также обновляем Redux для совместимости (можно будет удалить позже)
      dispatch(setAuthToken(newToken));

      console.log("✅ Токен успешно обновлен");
      return newToken;
    } catch (error) {
      console.log("❌ Ошибка refresh токена:", error?.response?.status);

      // Если получили 401 на refresh - значит refresh токен тоже невалидный
      if (error?.response?.status === 401) {
        console.log("🚪 Refresh токен невалидный, выходим из аккаунта");

        // Очищаем все данные и выходим
        dispatch(clearAllUserData());
        dispatch(clearAuthData());

        // Перенаправляем на главную
        window.location.href = "/";
      }

      throw error; // Пробрасываем ошибку дальше
    }
  };

  return refresh;
};

export default useRefreshToken;
